import { Collection } from 'firestorter';
import CollectionName from '../../utils/collections';
import BaseDocument from '../../Model/BaseDocument';

// Tag of the coach's default check-in template (used when a client has no
// custom-tag-specific template). Shared by the config page and the check-in views.
const DEFAULT_TAG = 'default';

class AppCustomCheckin extends BaseDocument {
  constructor(id, opts) {
    super(`${CollectionName.APP_CUSTOM_CHECK_IN}/${id}`, opts);
  }

  get checkInQuestions() {
    return this.data.checkInQuestions || [];
  }

  get checkInQuestionDefinition() {
    return this.data.checkInQuestionDefinition;
  }

  get checkInDay() {
    return this.data.checkInDay || 0;
  }

  get isImageUploadCompulsory() {
    return !!this.data.isImageUploadCompulsory;
  }

  get checkInDayUpdatedAt() {
    return this.data.checkInDayUpdatedAt;
  }

  get checkInDayUpdatedBy() {
    return this.data.checkInDayUpdatedBy;
  }

  get tag() {
    return this.data.tag;
  }

  setCheckinQuestions(checkInQuestions, lastUpdatedBy) {
    this.updateFields({
      checkInQuestions,
      lastUpdatedAt: new Date(),
      lastUpdatedBy,
    });
  }

  setCheckinQuestionDefinition(checkInQuestionDefinition, lastUpdatedBy) {
    this.updateFields({
      checkInQuestionDefinition,
      lastUpdatedAt: new Date(),
      lastUpdatedBy,
    });
  }

  setCheckInDay(checkInDay) {
    this.updateFields({
      checkInDay,
      checkInDayUpdatedAt: new Date(),
    });
  }

  setCheckInDayUpdatedBy(checkInDayUpdatedBy) {
    this.updateFields({
      checkInDayUpdatedBy,
    });
  }

  setImageUploadRequirement(required = false, lastUpdatedBy) {
    this.updateFields({
      isImageUploadCompulsory: required,
      imageUploadCompulsoryUpdatedAt: new Date(),
      imageUploadCompulsoryUpdatedBy: lastUpdatedBy,
    });
  }

  deleteDoc() {
    this.delete();
  }

  static addDoc = async (data) => {
    const customCheckInCollection = new Collection(CollectionName.APP_CUSTOM_CHECK_IN);
    const customCheckInDoc = await customCheckInCollection.add(data);
    const appCustomCheckInDoc = new AppCustomCheckin(customCheckInDoc.id);
    await appCustomCheckInDoc.init();
    return appCustomCheckInDoc;
  };

  static async getById(id) {
    const appCustomCheckInDoc = new AppCustomCheckin(id);
    await appCustomCheckInDoc.init();
    return appCustomCheckInDoc.exists ? appCustomCheckInDoc : null;
  }

  static async getCheckinDocsByCoachId(coachId) {
    const customCheckinCollection = new Collection(CollectionName.APP_CUSTOM_CHECK_IN, {
      createDocument: ({ id }, opts) => new AppCustomCheckin(id, opts),
      query: (ref) => ref.where('coachId', '==', coachId),
    });

    await customCheckinCollection.fetch();
    return customCheckinCollection;
  }
}

export default AppCustomCheckin;
export {
  DEFAULT_TAG,
};
